import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { cloneDeep } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Fill } from 'ol/style';
import { ConfigurationModel } from 'src/app/models/configuration';
import { LayerColor } from 'src/app/models/UserSettings';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { UserSettingsService } from 'src/app/services/userSettings.service';
import { RGBColor, UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-color-gradient-cumulative-coverage',
  templateUrl: './color-gradient-cumulative-coverage.component.html',
  styleUrls: ['../../app.component.scss', './color-gradient-cumulative-coverage.component.scss'],
  standalone: false
})
export class ColorGradientCumulativeCoverageComponent implements OnInit {

  constructor(public bsModalRef : BsModalRef,
  public utilsService: UtilsService,
  public calculationService: CalculationsService,
  public configurationService: ConfigurationService,
  ) { }
  layerIDs: number[] = Array.from({length: 100}, (_, index) => index + 1);

  firstLayer:number = 1;
  firstLayerColor:string="#00FFFF"

  lastLayer:number = 100;
  lastLayerColor:string = "#000000";
  form : UntypedFormGroup;


  @Input() cumulativeCoverageColors :any[];


  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      lastLayerForm : new UntypedFormControl(this.lastLayer, Validators.min(1))
    })
  }

  applyChange(){
    this.configurationService.currentConfiguration.cumulativeColorSettingsJson = JSON.stringify(this.cumulativeCoverageColors)
    this.configurationService.saveConfiguration(ConfigurationModel.mapToService(this.configurationService.currentConfiguration)).subscribe((result) =>{});
    this.calculationService.changeCumulativeCoverageColors(this.cumulativeCoverageColors);
  }
  applyGradient(){
    let numLayers:number = this.lastLayer - this.firstLayer;
    let startColor: RGBColor = this.utilsService.hexToRgb(this.firstLayerColor);
      let endColor: RGBColor = this.utilsService.hexToRgb(this.lastLayerColor);
    for (let  i = 0, j = 0; i < this.cumulativeCoverageColors.length; i++) {
      if(i + 1 < this.firstLayer)
        continue;
      if(i + 1 > this.lastLayer)
        break;
      if (numLayers == 0)
				numLayers = 1;
      let ratio: number = j / numLayers;

      let rgbColor:RGBColor = new RGBColor();
      rgbColor.red  = endColor.red * ratio + startColor.red*(1 - ratio);
      rgbColor.green  = endColor.green * ratio + startColor.green*(1 - ratio);
      rgbColor.blue  = endColor.blue * ratio + startColor.blue*(1 - ratio);
      this.cumulativeCoverageColors[i].color = this.utilsService.rgbToHex(rgbColor.red,rgbColor.green,rgbColor.blue);
      j++;
    }
  }
}
